export default __webpack_public_path__ + "static/Testimonial-a7d6e542fc920ce1e7253be566c9df09.png";